import { Brick, registerBrick } from 'olympe';
import BCP from './DM_BCP';
import { getLogger } from '@olympeio/core';
import { BCP_WORKFLOW_STATES, allWorkflowStates, ADMIN_FIRST_ACCEPTANCE } from './BcpWorkflowAuthorizations';
export default class BCPRequestWorkflowGenerationForStepper extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} bCPRequest
     * @param {*} workflowHistory
     * @param {function()} forwardEvent
     * @param {function(*)} setOutputObject
     */
    update($, [bCPRequest, workflowHistory, determineQAAcceptance], [forwardEvent, setOutputObject]) {

        getLogger('Workflow steeper').info("checking input data", bCPRequest, workflowHistory)
        // Workflow states order

        const getSecondQAApproval = () => {
            const SQAPerson = bCPRequest.get(BCP.qualityAssuranceProp)?.split(";")?.[1];
            const QAinFactoryPerson = bCPRequest.get(BCP.qaInFactoryProp)?.split(";")?.[1];
            getLogger('Workflow steeper').info("current workflow", determineQAAcceptance)
            const QA2 = determineQAAcceptance === ADMIN_FIRST_ACCEPTANCE.ACCEPT_AS_SQA ? [QAinFactoryPerson, "QA"] : [SQAPerson, "SQA"]

            getLogger('Workflow steeper').info("Secondary QA approval assigned to:", QA2);
            return QA2
        }
        


        // Extract the states from the input workflow history
        const inputStates = workflowHistory.map(item => item.State);
        let output = [];

        if (inputStates.includes("Completed")) {
            // Case 1: If "Completed" state exists
            output = workflowHistory;
            getLogger('Workflow steeper').info("Output: Workflow contains 'Completed'. Returning original input.", workflowHistory);

        } else if (inputStates.includes("Rejected")) {
            // Case 2: If "Rejected" state exists
            const rejectedIndex = inputStates.indexOf("Rejected");

            // Add all input states until "Rejected"
            output.push(...workflowHistory);

            const previousObject = workflowHistory[rejectedIndex - 1];
            
            // Add "Not started" for remaining workflow states not in the input
            allWorkflowStates.forEach(({ State, Assignee }) => {
                if (!inputStates.includes(State) && State !== "Rejected" && State !== "Completed") {
                    output.push({
                        State: "Not started",
                        Assignee: State === "Waiting on completion criteria" ? "WC" : Assignee,
                    });
                }
            });

            getLogger('Workflow steeper').info("Output: Workflow contains 'Rejected'. Generated inactive states.", output);

        } else {
            // Case 3: No "Completed" or "Rejected" state found
            output.push(...workflowHistory);
            // Function to get the assignee for the current workflow state
            const getStateName = () => {
                
                if (workflowHistory[workflowHistory.length - 1].State === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2) {
                    return getSecondQAApproval()[1];
                }
                else {
                    const state = allWorkflowStates.find(workflow => workflow.State === workflowHistory[workflowHistory.length - 1].State);
                    return state ? state.Assignee : null
                }

            }
            // Add "In Progress" for the first inactive state
            const firstInactiveState = {
                State: workflowHistory.length > 0
                    ? workflowHistory[workflowHistory.length - 1].State === "Waiting on completion criteria"
                        ? "Waiting validation"
                        : "In Progress"
                    : null,
                Assignee: workflowHistory.length > 0
                    ? getStateName()
                    : null,
                InprogressState: workflowHistory[workflowHistory.length - 1].State
            };

            if (!firstInactiveState.Assignee) {
                firstInactiveState.Assignee = "No assignee found";
            }

            output.push(firstInactiveState);

            // Add "Not started" for remaining workflow states not in the input
            allWorkflowStates.forEach(({ State, Assignee }) => {
                if (!inputStates.includes(State) && State !== "Completed" && State !== "Rejected") {
                    output.push({
                        State: "Not started",
                        Assignee: State === "Waiting on completion criteria" ? "WC" : Assignee,
                    });
                }
            });

            getLogger('Workflow steeper').info("Output: No 'Completed' or 'Rejected'. Generated inactive states with 'In Progress' first.", output);
        }

        // Unified call for `setOutputObject` and `forwardEvent`
        setOutputObject(output);
        forwardEvent();
    }

}

registerBrick('01936c6c8b7abf7bf249', BCPRequestWorkflowGenerationForStepper);


